export default function abstractComponent(hoc){
	return function hocWrapper(render, ...hocParams){
		const InheritedComponent = hoc(render, ...hocParams);
		InheritedComponent.displayName = render.displayName || render.name || hoc.name;
		return InheritedComponent;
	}
}
